@if (isVisible) {
  <div [formGroup]="formGroup">
    <input class="show-for-sr" type="checkbox" [id]="controlId" [name]="controlName" [(ngModel)]="contextValue" [formControlName]="componentData.key" (ngModelChange)="change()">
    <div class="toggle-background">
      <div class="choice-bar" [ngClass]="{ 'active': contextValue }">
        <div class="choice">Yes</div>
        <label [for]="controlId" class="thumb wrap-text"></label>
        <div class="choice">No</div>
      </div>
    </div>
    <form-control-label [id]="controlId" [question]="componentData"></form-control-label>
  </div>
}
